import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TixAuthService } from '@tix/auth/services';
import { TixExchangeRedirectCodeForTokenGQL } from '@tix/data-access';

@Component({
  selector: 'tix-login-with-redirect',
  templateUrl: './login-with-redirect.component.html'
})
export class LoginWithRedirectComponent implements OnInit {
  constructor(
    private authService: TixAuthService,
    private route: ActivatedRoute,
    private exchangeRedirectCodeForTokenMutation: TixExchangeRedirectCodeForTokenGQL
  ) {}

  async ngOnInit() {
    const redirectCode = decodeURIComponent(
      this.route.snapshot.queryParamMap.get('redirectCode') ?? ''
    );
    const nextRouteEncoded =
      this.route.snapshot.queryParamMap.get('redirect') ??
      this.route.snapshot.queryParamMap.get('redirectRoute');

    const nextRoute = nextRouteEncoded
      ? decodeURIComponent(nextRouteEncoded)
      : '/';

    if (!redirectCode) {
      alert('You followed a broken link');
      window.location.href = '/';

      return;
    }

    try {
      const response = await this.exchangeRedirectCodeForTokenMutation
        .mutate({ redirectCode })
        .toPromise();
      const token = response.data?.exchangeRedirectCodeForToken;

      if (!token) throw new Error('No token returned');

      await this.authService.signInWithToken(token).toPromise();
    } catch (error) {
      console.error(
        'Failed to exchange the redirect code for a token: ',
        error
      );
      alert('Please sign in to access this page');
      window.location.href = '/auth/login?r=' + nextRoute;
    }

    window.location.href = nextRoute;
  }
}
